import { Toast } from '@byecode/ui'
import { type FlowEdge, type FlowNode, updateWorkflowErrorMessage, useAtomAction } from '@lighthouse/shared'
import { useReactFlow } from '@xyflow/react'
import { useCallback } from 'react'

import { workflowAtomFamily } from '@/atoms/workflow/state'
import { useFlowContainerContext } from '@/contexts/FlowContext'
import { useWorkSpace } from '@/hooks/useWorkSpace'
import * as srv from '@/services'

import { resolveWebhookNodes } from '../utils/webhookUrl'

export const usePersistFlow = () => {
    const { id, enabled, runType, setErrorMap, setIsChanged } = useFlowContainerContext()
    const { run: updateWorkflow } = useAtomAction(workflowAtomFamily(id))
    const { getNodes, getEdges } = useReactFlow()
    const { apiKey } = useWorkSpace()

    const persistFlow = useCallback(async () => {
        const nodes = resolveWebhookNodes(getNodes() as FlowNode[], apiKey)
        const edges = getEdges() as FlowEdge[]

        if (enabled) {
            try {
                const updated = await srv.updateAndEnableWorkflow({ id, nodes, edges, runType })
                if (updated.success) {
                    updateWorkflow({ id, content: { nodes, edges } })
                    Toast.success('更新成功')
                    setIsChanged?.(false)
                    return true
                }

                setErrorMap?.(updated.errorMap)
                Toast.error(updateWorkflowErrorMessage)
            } catch {
                Toast.error('更新失败，请稍后重试')
            }
            return false
        }

        const updated = await srv.updateFlow({
            id,
            nodes,
            edges,
            runType
        })
        if (updated) {
            updateWorkflow({ id, content: { nodes, edges } })
            Toast.success('更新成功')
            setIsChanged?.(false)
        }
        return updated
    }, [apiKey, enabled, getEdges, getNodes, id, runType, setErrorMap, setIsChanged, updateWorkflow])

    return {
        persistFlow
    }
}
